import { render, staticRenderFns } from "./AgendaReschedule.vue?vue&type=template&id=120b97b6"
import script from "./AgendaReschedule.vue?vue&type=script&lang=js"
export * from "./AgendaReschedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports